export const CONTENT_QUESTIONS_I = 'content-1-details';
export const CONTENT_QUESTIONS_II = 'content-2-details';
export const CONTENT_QUESTIONS_III = 'content-3-details';
export const CONTENT_QUESTIONS_IV = 'content-4-details';

export const CONTENT_QUESTIONS_I_FIELDS = [
    {
        sectionID: CONTENT_QUESTIONS_I,
        fieldList: [
            {
                id: 'question',
                options: [
                    { optID: 'Yes', optLabel: 'Yes' },
                    { optID: 'No', optLabel: 'No' }
                ],
                label: 'Q1. Does the game contain any of the following materials?',
                display: 'inline',
                type: 'radio',
                span: 12,
                rule: {
                    required: true
                }
            },
            {
                id: 'heading-1',
                type: 'label',
                variant: 'h4',
                label: 'Gambling',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-1',
                type: 'label',
                label: '- This refers to betting, gambling games or other games of chance that are normally played for money. It includes titles which are instructional and teaches a player how to play those games. (This does not cover games where gambling is no the main feature but occurs as minor part of the storyline, eg. Mini-games in RPGs.)',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-2',
                type: 'label',
                variant: 'h4',
                label: 'Religious content / elements',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-2',
                type: 'label',
                label: '- This refers to games containing religious content or elements. The religious content could be either a major or minor element in the game.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-3',
                type: 'label',
                variant: 'h4',
                label: 'Terrorism',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-3',
                type: 'label',
                label: '- This refers to games with terrorism as part of its plot.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-4',
                type: 'label',
                variant: 'h4',
                label: 'Politics',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-4',
                type: 'label',
                label: '- This refers to games where politics or political situations are a feature of the game.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            }
        ]
    }
];
export const CONTENT_QUESTIONS_II_FIELDS = [
    {
        sectionID: CONTENT_QUESTIONS_II,
        fieldList: [
            {
                id: 'question',
                options: [
                    { optID: 'Yes', optLabel: 'Yes' },
                    { optID: 'No', optLabel: 'No' }
                ],
                label: 'Q2. Does the game contain any of the following materials?',
                display: 'inline',
                type: 'radio',
                span: 12,
                rule: {
                    required: true
                }
            },
            {
                id: 'heading-1',
                type: 'label',
                variant: 'h4',
                label: 'Material which may undermine national interest',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-1',
                type: 'label',
                label: '- This refers to content which may undermine public order or social stability',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-2',
                type: 'label',
                variant: 'h4',
                label: 'Material which is likely to offend a race or religion in Singapore',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-2',
                type: 'label',
                label: '- This refers to content which may cause misunderstanding, incite hatred or strife among religious groups. It includes the use of religious symbols or figures which may be blasphemous',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-3',
                type: 'label',
                variant: 'h4',
                label: 'Material that deals with alternative lifestyle, depict sexual violence, explicit sexual activity, or deviant sexual activity',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-3',
                type: 'label',
                label: `- Explicit sexual activity refers to content depicting actual sexual intercourse and scenes of couple copulating where genitals may or may not be visible. 
                        - Deviant sexual activity refers to, but are not limited to activities such as necrophilia, bestiality, pedophilia, and incest. 
                        - Alternative lifestyles include, but is not limited to homosexuality, wife-swapping, swinging.`,
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-4',
                type: 'label',
                variant: 'h4',
                label: 'Material that depicts criminal activities with clear instructional details',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-4',
                type: 'label',
                label: '- This refers to content which may show how the offences can be carried out, e.g. step-by-step guide to making a bomb.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-5',
                type: 'label',
                variant: 'h4',
                label: 'Material which depict sadistic and cruel violence to human-like characters',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-5',
                type: 'label',
                label: '- This refers to content with a sadistic intent where the acts of violence are detailed, such as horrific, brutal or repulsive depictions of death, injury, dismemberment or torture and other methods of bringing severe pain or injury to the recipient. These violent acts are often accompanied by large amount of blood and gore.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-6',
                type: 'label',
                variant: 'h4',
                label: 'Exploitative nudity',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-6',
                type: 'label',
                label: '- This refers to instances where male and female nudity where gentials are clearly depicted. This would include content where the presentation of nudity is exploitative and is a constant feature.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-7',
                type: 'label',
                variant: 'h4',
                label: 'Instructive details of consumption of illegal drugs or content that encourages drug use',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-7',
                type: 'label',
                label: '- This refers to content which serves as a step-by-step guide to the preparation and consumption of illegal drugs.- The game glamorises drug use and encourages the use of illegal drug.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            }
        ]
    }
];
export const CONTENT_QUESTIONS_III_FIELDS = [
    {
        sectionID: CONTENT_QUESTIONS_III,
        fieldList: [
            {
                id: 'question',
                options: [
                    { optID: 'Yes', optLabel: 'Yes' },
                    { optID: 'No', optLabel: 'No' }
                ],
                label: 'Q3. Does the game contain any of the following materials?',
                display: 'inline',
                type: 'radio',
                span: 12,
                rule: {
                    required: true
                }
            },
            {
                id: 'heading-1',
                type: 'label',
                variant: 'h4',
                label: 'Content that requires the player to engage in illegal activities or play the role of a criminal, but does not have instructional details',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-1',
                type: 'label',
                label: "- The theme of these games involves the player's participation in crime or other illegal activities. Such games will allow a player to commit crime as part of their main mission or encourage the player to build up a criminal empire. This does not include comic or cartoon-like depiction of crime capers.",
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-2',
                type: 'label',
                variant: 'h4',
                label: 'Depictions of realistic violence such as killing or causing serious injury to human-like characters',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-2',
                type: 'label',
                label: "- Such games involve the killing and causing of injury to human-like characters where the depiction of violence is realistic, i.e. body parts being severed and other methods of causing death, severe pain or injury, are presented in clear detail, e.g. a person's body splits into two when slashed, with spraying of blood/organs. The action may involve motiveless and random killing or injury to characters such as pedestrians in the streets.",
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-3',
                type: 'label',
                variant: 'h4',
                label: 'Materials which depicts sexual activity',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-3',
                type: 'label',
                label: '- This refers to content where depiction of sexual activity with some nudity occurs. Homosexual activity should be limited to kissing and hugging.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-4',
                type: 'label',
                variant: 'h4',
                label: 'Non-exploitative nudity or materials which could be sexually titillating',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-4',
                type: 'label',
                label: '- Non-exploitative nudity refers to instances where nudity is not the main feature of the game. This includes depiction of topless nudity as well as occasional frontal nudity which is human-like. Nudity in the game may not have the intent to titillate. Sexually titillating materials include moving or still images (including partial nudity) that are sexually suggestive. Such materials are those that use images, for example scantily-clad women, in a manner that is titillating.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-5',
                type: 'label',
                variant: 'h4',
                label: 'Strong and frequent coarse language',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-5',
                type: 'label',
                label: '- This refers to strong coarse language used frequently in the game. It includes sexual expletives such as "cunt" and "cocksucker".',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-6',
                type: 'label',
                variant: 'h4',
                label: 'Realistic depiction of frequent illegal drug use',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-6',
                type: 'label',
                label: '- The primary intent should not encourage the consumption of drug to achieve success, e.g. kill the enemy or to complete the level. Realistic depiction of drug use refers to the depiction of real-life substance abuse but does not include instructive details. For example, showing a character injecting drug into his arm is allowed but the full method of preparation should not be permitted',
                span: 12,
                rule: {
                    previewHidden: true
                }
            }
        ]
    }
];
export const CONTENT_QUESTIONS_IV_FIELDS = [
    {
        sectionID: CONTENT_QUESTIONS_IV,
        fieldList: [
            {
                id: 'question',
                options: [
                    { optID: 'Yes', optLabel: 'Yes' },
                    { optID: 'No', optLabel: 'No' }
                ],
                label: 'Q4. Does the game contain any of the following materials?',
                display: 'inline',
                type: 'radio',
                span: 12,
                rule: {
                    required: true
                }
            },
            {
                id: 'heading-1',
                type: 'label',
                variant: 'h4',
                label: 'Depictions of moderate violence such as killing or causing injury to human-like characters',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-1',
                type: 'label',
                label: '- This include games where all or the majority of the gameplay involve violence with depiction of blood. It includes shooting games where a moderate amount of blood is depicted. The level of details of injury or killing is kept to a minimum. This includes fighting games which depicts some amount of blood and gore.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-2',
                type: 'label',
                variant: 'h4',
                label: 'Images or words that imply sexual activity',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-2',
                type: 'label',
                label: '- This refers to sexual innuendos relating to sexual intercourse or foreplay, and.can consist of words and/or activity. It includes occasions where it is clearly implied that the characters are engaging in sexual activity.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-3',
                type: 'label',
                variant: 'h4',
                label: 'Nudity in a non-sexual context',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-3',
                type: 'label',
                label: '- This refers to nudity which does"ot contain details, e.g. no nipples, genitalia or pubic region (includes hair).',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-4',
                type: 'label',
                variant: 'h4',
                label: 'Depictions of materials which could be mildly suggestive',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-4',
                type: 'label',
                label: '- These include moving or still images which use scantily-clad women in bikinis or lingerie in a manner which could be sexually suggestive.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-5',
                type: 'label',
                variant: 'h4',
                label: 'Some coarse language',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-5',
                type: 'label',
                label: '- This refers to infrequent coarse language use. Use of occasional expletives such as "fuck" as a swear word is permissible.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-6',
                type: 'label',
                variant: 'h4',
                label: 'Depictions of drug use or substance abuse',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-6',
                type: 'label',
                label: '- This refers to any illegal drug use or substance abuse which may be implied.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'heading-7',
                type: 'label',
                variant: 'h4',
                label: 'Depictions of horror',
                span: 12,
                rule: {
                    previewHidden: true
                }
            },
            {
                id: 'body-7',
                type: 'label',
                label: '- This refers to depictions of frightening and disturbing sequences, or any abhorrent phenomena, whether natural or pertaining to the supernatural.',
                span: 12,
                rule: {
                    previewHidden: true
                }
            }
        ]
    }
];
